import React from "react";
import { Alert } from "@mui/material";
import PolicyLayout, { PolicySection } from "./PolicyLayout";

export default function Privacy() {
  return (
    <PolicyLayout title="Privacy Policy">
      <Alert severity="info">
        Draft for review. This notice is not final; provider details, data-sharing
        practices, retention periods, and privacy request procedures still need confirmation.
      </Alert>
      <PolicySection title="Scope">
        This draft describes information used by the ProspectEngage application.
        Your organization manages the business records it adds to its workspace
        and may provide additional notices about its use of that information.
      </PolicySection>
      <PolicySection title="Account and workspace information">
        The platform processes account information such as your email address,
        organization, and access permissions to support sign-in and workspace
        access. Workspace content may include company and contact records,
        business contact details, notes, projects, survey responses, and uploaded
        documents, depending on the features your organization uses.
      </PolicySection>
      <PolicySection title="How information is used">
        Information is used to provide the features you and your organization
        select, including managing records, researching prospects, preparing
        reports, tracking activities, and supporting outreach. Access to workspace
        information depends on account permissions and your organization’s configuration.
      </PolicySection>
      <PolicySection title="Connected services and AI features">
        Connecting Microsoft services enables features that access email or
        calendar information under the permissions granted. Research, website
        tracking, and AI features may process information through external
        providers. The information involved depends on the feature and the
        content submitted. Review connected-service permissions before enabling
        an integration or submitting confidential information.
      </PolicySection>
      <PolicySection title="Browser storage">
        ProspectEngage uses browser local storage and session storage for
        authentication and application state. Microsoft authentication also uses
        browser storage. Clearing stored information may sign you out or reset
        preferences; browser settings let you manage this storage.
      </PolicySection>
      <PolicySection title="Managing your information">
        Contact your organization’s administrator or your existing ProspectEngage
        contact about access, corrections, deletion requests, or connected-service
        permissions. Workspace records may be managed by your organization, so
        changes may require its involvement.
      </PolicySection>
      <PolicySection title="Final notice">
        A finalized notice will need to identify the service provider and privacy
        contact, explain applicable sharing and retention practices, and describe
        available privacy rights and how to exercise them.
      </PolicySection>
    </PolicyLayout>
  );
}
